module.exports = __webpack_public_path__ + "img/uk-diabetes-mellitus-female.0b70e638.png";